export default {
  root: {
    padding: '2px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    },
    outline: "none",
    '&:focus': {
      outline: "none",
    }
  }
};
